import React, { useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import { languageHelper } from "../../../config/helperFunctions";
import axios from "axios";
import { apiKey } from "../../../config/config";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function DeliveryCompanies() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Company Name"),
      accessorKey: "company_name",
    },
    {
      header: languageHelper("Status"),
      accessorKey: "status",
      cell: (row) =>
        row.getValue() === "active"
          ? languageHelper("Active")
          : languageHelper("Inactive"),
    },
    {
      header: languageHelper("Actions"),
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ];

  const [data, setData] = useState([]);
  const [error, setError] = useState(false);

  const navigate = useNavigate();

  const dropdownOptions = [
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => {
        navigate(`AddDeliveryCompanyForm/${id}`);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrashAlt />,
      func: (id) => {
        // Handle edit action
      },
    },
  ];

  const buttonData = [
    {
      buttonText: languageHelper("Add Delivery Company"),
      path: "AddDeliveryCompanyForm",
    },
  ];

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/deliveryCompanies`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((response) => {
        setData(response.data);
        setError(false);
      })
      .catch((error) => {
        setError(
          error.response.data.message || "Error fetching delivery companies:"
        );
      });
  }, [user?.token]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        buttonData={buttonData}
        heading={languageHelper("Delivery Companies")}
        error={error}
      />
    </main>
  );
}

export default DeliveryCompanies;
